import { api } from '../../../lib/api.js';

/**
 * GET /v1/courses/:courseId
 * Coach config nested at data.coursedetails.coach_details + calendly_url.
 */
export async function fetchCourseDetail(courseId) {
  const res = await api.request({ url: `courses/${courseId}`, method: 'GET' });
  return res.data;
}

/**
 * GET /v1/user_tasks — user-wide assignment list.
 * Task fields: { schedule_id, task_name, task_file }
 */
export async function fetchUserTasks() {
  const res = await api.request({ url: 'user_tasks', method: 'GET' });
  return res.data;
}

/**
 * POST /v1/user_tasks — multipart submit. task_file + schedule_id.
 */
export async function submitAssignment({ file, scheduleId }) {
  const fd = new FormData();
  fd.append('task_file', file);
  fd.append('schedule_id', String(scheduleId));
  const res = await api.request({ url: 'user_tasks', method: 'POST', data: fd });
  return res.data;
}

/**
 * GET /v1/coach_call_history — user-wide call history.
 * Call fields: { call_status, call_time, call_type, call_url, audio_files, call_recording }
 */
export async function fetchCallHistory() {
  const res = await api.request({ url: 'coach_call_history', method: 'GET' });
  return res.data;
}

/**
 * POST /v1/reschedule_coach_call — cancel/reschedule a booked call.
 */
export async function rescheduleCall({ scheduleId, reasonType, reason }) {
  const res = await api.request({
    url: 'reschedule_coach_call',
    method: 'POST',
    data: { schedule_id: scheduleId, reason_type: reasonType, reason },
  });
  return res.data;
}

/**
 * POST /v1/updateuserrole — coach intake form (v1 hardcoded shape).
 */
export async function submitIntake({ userBackground, userRole, userSkill }) {
  const res = await api.request({
    url: 'updateuserrole',
    method: 'POST',
    data: {
      user_background: userBackground,
      user_role: userRole,
      user_skill: userSkill,
    },
  });
  return res.data;
}
